import React, { useState, useEffect } from 'react';
import { IP_KEYS, IP_LABEL, IP_ROUTING_MAPPING } from '../../../common/constants/app.constants';
import Select from 'b2b-ui-components-lib/lib/components/select';
import { MEDIA_TYPES } from 'dedicated/components/choose-plan/plan.service';

const IpDetails = (props) => {
  let { selectedIpDetails, apiIpDetails, updateSelectedIpDetails, setSubNetDetails, lineItemIndex, primaryMedia = {}, selectedserviceOption } = props;
  let [activeDropDown, setDropDownStatus] = useState(-1);
  let [callUseEffect, setUseEffectState] = useState(false);
  let [getDefaultIpDetails, seDefaultIpDetails] = useState({});

  const updateSelectedOption = (name, selectedIpIndex, value, subnetDropDown) => {
    setUseEffectState(true);

    if (subnetDropDown) {
      selectedIpDetails[selectedIpIndex][IP_KEYS.IP_SUBNET][name] = value;
      updateSelectedIpDetails(selectedIpDetails);
    } else {
      selectedIpDetails[selectedIpIndex][name] = value;
      if (name === IP_KEYS.IP_TYPE || name === IP_KEYS.IP_VERSION) {
        setSubNetDetails(selectedIpDetails[selectedIpIndex], apiIpDetails, selectedIpIndex, lineItemIndex);
      } else if (name === IP_KEYS.ROUTING_PROTOCOL) {
        let previousIpType = selectedIpDetails[selectedIpIndex][IP_KEYS.IP_TYPE];
        selectedIpDetails[selectedIpIndex][IP_KEYS.IP_TYPE] = IP_ROUTING_MAPPING[value.key];
        if (IP_ROUTING_MAPPING[value.key] !== previousIpType) {
          setSubNetDetails(selectedIpDetails[selectedIpIndex], apiIpDetails, selectedIpIndex, lineItemIndex);
        }
        updateSelectedIpDetails(selectedIpDetails);
      } else {
        updateSelectedIpDetails(selectedIpDetails);
      }
    }

    if ((name === 'routingProtocol' && value?.key === 'None') || (name === 'ipVersion' && selectedIpDetails[selectedIpIndex][IP_KEYS.ROUTING_PROTOCOL]?.key === 'None')) {
      selectedIpDetails[selectedIpIndex][IP_KEYS.IP_SUBNET]['lanIPSubnet'] = { key: 'None', displayName: 'None' };
      selectedIpDetails[selectedIpIndex][IP_KEYS.IP_SUBNET]['wanIPSubnet'] = { key: 'None', displayName: 'None' };
      selectedIpDetails[selectedIpIndex][IP_KEYS.IP_SUBNET]['lanIPV6Subnet'] = { key: 'None', displayName: 'None' };
      selectedIpDetails[selectedIpIndex][IP_KEYS.IP_SUBNET]['wanIPV6Subnet'] = { key: 'None', displayName: 'None' };
    }
  };

  useEffect(() => {
    setDropDownStatus(-1);
    setUseEffectState(false);
  }, [callUseEffect]);

  useEffect(() => {
    let defaultIpDetails = {};
    if (apiIpDetails && apiIpDetails.configAttributesMap) {
      let newObj = {};
      newObj.ipVersion = apiIpDetails.configAttributesMap.ipVersion;

      if (primaryMedia && (primaryMedia?.key === MEDIA_TYPES.FOUR_G || primaryMedia?.key === MEDIA_TYPES.FIVE_G)) {
        newObj.ipVersion = {
          ...newObj.ipVersion,
          values: newObj.ipVersion?.values?.filter((item) => item !== 'IPV6' && item !== 'Dual Stack')
        };
      }
      newObj.routingProtocol = apiIpDetails.configAttributesMap.routingProtocol;
      defaultIpDetails = { ...newObj, ...apiIpDetails };
    } else {
      defaultIpDetails = apiIpDetails;
    }
    seDefaultIpDetails(defaultIpDetails);
  }, [primaryMedia]);

  useEffect(() => {
    if (selectedserviceOption?.value !== 'UNMANAGED') {
      const defaultValue = getDefaultIpDetails?.routingProtocol?.defaultValue || 'Static';
      updateSelectedOption('routingProtocol', 0, { displayName: defaultValue, key: defaultValue }, null);
    }
  }, [selectedserviceOption]);

  const renderMinMaxComponent = (obj, selectedIpIndex, subnetDropDown) => {
    let min = obj[1].min;
    let max = obj[1].max;
    let arr = [];
    while (min <= max) {
      arr.push(max);
      max--;
    }

    const isRoutingProtocolNone = selectedIpDetails[selectedIpIndex]?.routingProtocol?.key === 'None';
    const isLanWanSubnetFields = obj[0] === 'lanIPSubnet' || obj[0] === 'wanIPSubnet' || obj[0] === 'lanIPV6Subnet' || obj[0] === 'wanIPV6Subnet';

    let fieldValue = subnetDropDown ? selectedIpDetails[selectedIpIndex][obj[0]] : selectedIpDetails[selectedIpIndex][IP_KEYS.IP_SUBNET][obj[0]];
    const isLanWanSubnetNone = isRoutingProtocolNone && isLanWanSubnetFields && fieldValue?.key === 'None';

    let optionsList = arr && arr.length && arr.map((item) => ({ displayName: subnetDropDown || isLanWanSubnetNone ? item : '/' + item, key: item }));
    let setDropDown = IP_KEYS.NO_OF_LAN === obj[0] || obj[0] === IP_KEYS.NO_OF_WAN ? false : true;

    let isDisabled = false;

    if (isLanWanSubnetNone) {
      fieldValue.displayName = 'None';
      isDisabled = true;
    } else {
      fieldValue = fieldValue || optionsList?.[0];
      isDisabled = false;
    }

    return (
      <div className="flg-lg-6 flg-md-6">
        <Select
          label={IP_LABEL[obj[0]]}
          value={fieldValue}
          onChange={(value) => updateSelectedOption(obj[0], selectedIpIndex, value, setDropDown)}
          options={optionsList}
          disabled={isDisabled}
          required
        />
      </div>
    );
  };
  const renderValuesComponent = (obj, selectedIpIndex) => {
    let values = obj[0] === IP_KEYS.ROUTING_PROTOCOL || obj[0] === IP_KEYS.IP_VERSION ? obj[1].values : obj[1];
    let optionsList = values && values.length && values.map((item) => ({ displayName: item, key: item }));
    let selectedValue = selectedIpDetails[selectedIpIndex][obj[0]];

    if (obj[0] === IP_KEYS.ROUTING_PROTOCOL) {
      if (selectedserviceOption?.value !== 'UNMANAGED') {
        optionsList = optionsList?.filter((item) => item.key !== 'None');
        selectedValue = optionsList?.[0];
      } else {
        optionsList?.push({ key: 'None', displayName: 'None' });
        // selectedValue = optionsList?.[0];
      }
    }

    return (
      <div className="flg-lg-6 flg-md-6">
        <Select label={IP_LABEL[obj[0]]} value={selectedValue} onChange={(value) => updateSelectedOption(obj[0], selectedIpIndex, value)} options={optionsList} required />
      </div>
    );
  };

  const renderRespectiveMap = (obj, selectedIpIndex) => {
    if (obj[0] === IP_KEYS.NO_OF_LAN || obj[0] === IP_KEYS.NO_OF_WAN) {
      return renderMinMaxComponent(obj, selectedIpIndex, true);
    } else if (obj[0] === IP_KEYS.ROUTING_PROTOCOL || obj[0] === IP_KEYS.IP_TYPE || obj[0] === IP_KEYS.IP_VERSION) {
      return renderValuesComponent(obj, selectedIpIndex);
    }
  };

  const returnSubnetDetails = (obj, selectedIpIndex) => {
    let selectedVersion = obj[1][selectedIpDetails[selectedIpIndex][IP_KEYS.IP_VERSION].key];
    if (selectedVersion) {
      let subnetDetails = selectedVersion[selectedIpDetails[selectedIpIndex][IP_KEYS.IP_TYPE].displayName];
      return Object.entries(subnetDetails).map((subnet, index) => {
        return renderMinMaxComponent(subnet, selectedIpIndex, false);
      });
    }
  };

  return (
    selectedIpDetails &&
    selectedIpDetails.map((selectedIpDetail, selectedIpIndex) => {
      return (
        getDefaultIpDetails &&
        Object.entries(getDefaultIpDetails).map((ipType) => {
          //if (ipType[0] !== IP_KEYS.NO_OF_LAN && ipType[0] !== IP_KEYS.NO_OF_WAN) {
          return ipType[0] !== IP_KEYS.IP_SUBNET ? renderRespectiveMap(ipType, selectedIpIndex) : returnSubnetDetails(ipType, selectedIpIndex);
          // }
        })
      );
    })
  );
};

export default IpDetails;
